module.exports = __webpack_public_path__ + "static/media/rate-now-button.137a9b27.png";